var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"IndexBox"},[_c('div',{staticClass:"ScrollBox"},[_c('img',{attrs:{"src":_vm.InitData.setting.profit_img,"width":"100%"}})]),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }